module.exports = __webpack_public_path__ + "assets/bebfdce18fb5a282aa768362529ca05c.png";